module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 81
// module chunks = 0